export function plural(n: number, word: string, pluralWord = `${word}s`): string {
  return `${n} ${n === 1 ? word : pluralWord}`;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0]![0] ?? '';
  const last = parts.length > 1 ? parts.at(-1)![0] ?? '' : '';
  return (first + last).toUpperCase();
}

/** "+447700900123" -> "07700 900123" for UK numbers. */
export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '';
  const uk = /^\+44(\d{4})(\d{6})$/.exec(e164);
  if (uk) return `0${uk[1]} ${uk[2]}`;
  const uk3 = /^\+44(\d{3})(\d{3})(\d{4})$/.exec(e164);
  if (uk3) return `0${uk3[1]} ${uk3[2]} ${uk3[3]}`;
  return e164;
}

export function metres(m: number): string {
  if (m < 10) return `${Math.round(m * 10) / 10} m`;
  return `${Math.round(m)} m`;
}

/** Text colour (black or white) that reads on a background colour. */
export function inkFor(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return '#ffffff';
  const n = parseInt(m[1]!, 16);
  const channel = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  const lum = 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
  return lum > 0.4 ? '#1a1a17' : '#ffffff';
}

export function capitalise(s: string): string {
  return s ? s[0]!.toUpperCase() + s.slice(1) : s;
}

export function classNames(...items: Array<string | false | null | undefined>): string {
  return items.filter(Boolean).join(' ');
}

export function spelledReference(ref: string): string {
  return ref.replace(/(.{3})(?=.)/g, '$1 ');
}
